import React, { Component } from "react";
import { DragDropContext } from 'react-beautiful-dnd';

class EpisodeMaker extends Component {
    render() {
        return (
            <div>
                <h1>
                    sajlkfsjd;lkfjas;dlfkjas;ldkfj;lk
                </h1>
            </div>
        )
    }
}

export default EpisodeMaker;